import type { paths } from "../api/generated/api-types";

type RoleListItem =
  paths["/roles"]["get"]["responses"]["200"]["content"]["application/json"]["items"][number];

// Mirror of backend BR-AC-05 for UI gating (a convenience layer over server
// enforcement). A target user is manageable when its role is strictly less
// privileged (greater level); the sole self-edit exception is a system-role
// current user acting on its own account.
export interface CurrentUserHierarchy {
  id: string;
  level: number;
  roleType: "system" | "user";
}

export class UserHierarchy {
  public static canManageUser(
    current: CurrentUserHierarchy,
    target: { id: string; role: { level: number } },
  ): boolean {
    const lessPrivileged = target.role.level > current.level;
    const ownSystemAccount = target.id === current.id && current.roleType === "system";
    return lessPrivileged || ownSystemAccount;
  }

  // Only roles strictly less privileged than the current user's own level may be
  // assigned (BR-AC-05); this also excludes system roles (level 0).
  public static assignableRoles(roles: RoleListItem[], currentLevel: number): RoleListItem[] {
    return roles.filter((role) => role.level > currentLevel);
  }
}
